import Vue from "vue";
export default {
  setLegueTabs(state, response) {
    Vue.set(state, "leaguesData", response);
  },
  setDefaultLeagueTeam(state, response) {
    Vue.set(state, "selectedTeams", response);
  },
  setSelectedLeague(state, response) {
    Vue.set(state, "selectedLeague", response);
  },
  setLoaded(state) {
    Vue.set(state, "isLoaded", true);
  },
  setPromoConfig(state, payload) {
    Vue.set(state, "promoConfig", payload);
  },
  setPromoContent(state, payload) {
    Vue.set(state, "promoContent", payload);
  },
  setSelectedLeagueId(state, response) {
    Vue.set(state, "selectedLeagueId", response);
  },
  setUserPick(state, payload) {
    Vue.set(state, "userPick", payload);
  },
  setEditState(state, payload) {
    Vue.set(state, "editState", payload);
  },
  setLeagueTable(state, payload) {
    Vue.set(state, "leagueTable", payload);
  },
  setLeagueMatches(state, payload) {
    Vue.set(state, "leagueMatches", payload);
  },
  setFocusedCharacter(state, payload) {
    Vue.set(state, "focusedCharacter", payload);
  },
  setPromotionStatus(state, payload) {
    Vue.set(state, "promoStatus", payload);
  },
  setApiData(state, payload) {
    Vue.set(state, "apiData", payload);
  }
};
